/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ContentEditorMetaMetaResponse,
  ContentEditorMetaUpdateResponse,
  ContentEditorShowResponse,
  ContentVersionCreateResponse,
  ContentVersionIndexResponse,
  ContentVersionShowResponse,
  ContentVersionUpdateResponse,
  VersionCreate,
  VersionUpdate,
  VersionUpdate1,
} from '../models';
import {
    ContentEditorMetaMetaResponseFromJSON,
    ContentEditorMetaMetaResponseToJSON,
    ContentEditorMetaUpdateResponseFromJSON,
    ContentEditorMetaUpdateResponseToJSON,
    ContentEditorShowResponseFromJSON,
    ContentEditorShowResponseToJSON,
    ContentVersionCreateResponseFromJSON,
    ContentVersionCreateResponseToJSON,
    ContentVersionIndexResponseFromJSON,
    ContentVersionIndexResponseToJSON,
    ContentVersionShowResponseFromJSON,
    ContentVersionShowResponseToJSON,
    ContentVersionUpdateResponseFromJSON,
    ContentVersionUpdateResponseToJSON,
    VersionCreateFromJSON,
    VersionCreateToJSON,
    VersionUpdateFromJSON,
    VersionUpdateToJSON,
    VersionUpdate1FromJSON,
    VersionUpdate1ToJSON,
} from '../models';

export interface CompanySpacesContentContentIdVersionsGetRequest {
    contentId: number;
}

export interface CompanySpacesContentContentIdVersionsIdDeleteRequest {
    contentId: number;
    id: string;
}

export interface CompanySpacesContentContentIdVersionsIdGetRequest {
    contentId: number;
    id: string;
    id2: number;
}

export interface CompanySpacesContentContentIdVersionsIdPutRequest {
    contentId: number;
    id: string;
    body?: VersionUpdate;
}

export interface CompanySpacesContentContentIdVersionsPostRequest {
    contentId: number;
    body?: VersionCreate;
}

export interface ContentEditorVersionsIdGetRequest {
    id: string;
}

export interface ContentEditorVersionsIdMetaGetRequest {
    id: string;
}

export interface ContentEditorVersionsIdMetaPutRequest {
    id: string;
    body?: VersionUpdate1;
}

/**
 * 
 */
export class VersionApi extends runtime.BaseAPI {

    /**
     */
    async companySpacesContentContentIdVersionsGetRaw(requestParameters: CompanySpacesContentContentIdVersionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentVersionIndexResponse>> {
        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
            throw new runtime.RequiredError('contentId','Required parameter requestParameters.contentId was null or undefined when calling companySpacesContentContentIdVersionsGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content/{content_id}/versions`.replace(`{${"content_id"}}`, encodeURIComponent(String(requestParameters.contentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentVersionIndexResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentContentIdVersionsGet(requestParameters: CompanySpacesContentContentIdVersionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentVersionIndexResponse> {
        const response = await this.companySpacesContentContentIdVersionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdDeleteRaw(requestParameters: CompanySpacesContentContentIdVersionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
            throw new runtime.RequiredError('contentId','Required parameter requestParameters.contentId was null or undefined when calling companySpacesContentContentIdVersionsIdDelete.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentContentIdVersionsIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content/{content_id}/versions/{id}`.replace(`{${"content_id"}}`, encodeURIComponent(String(requestParameters.contentId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdDelete(requestParameters: CompanySpacesContentContentIdVersionsIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.companySpacesContentContentIdVersionsIdDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdGetRaw(requestParameters: CompanySpacesContentContentIdVersionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentVersionShowResponse>> {
        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
            throw new runtime.RequiredError('contentId','Required parameter requestParameters.contentId was null or undefined when calling companySpacesContentContentIdVersionsIdGet.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentContentIdVersionsIdGet.');
        }

        if (requestParameters.id2 === null || requestParameters.id2 === undefined) {
            throw new runtime.RequiredError('id2','Required parameter requestParameters.id2 was null or undefined when calling companySpacesContentContentIdVersionsIdGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.id2 !== undefined) {
            queryParameters['id'] = requestParameters.id2;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/company_spaces/content/{content_id}/versions/{id}`.replace(`{${"content_id"}}`, encodeURIComponent(String(requestParameters.contentId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentVersionShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdGet(requestParameters: CompanySpacesContentContentIdVersionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentVersionShowResponse> {
        const response = await this.companySpacesContentContentIdVersionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdPutRaw(requestParameters: CompanySpacesContentContentIdVersionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentVersionUpdateResponse>> {
        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
            throw new runtime.RequiredError('contentId','Required parameter requestParameters.contentId was null or undefined when calling companySpacesContentContentIdVersionsIdPut.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling companySpacesContentContentIdVersionsIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content/{content_id}/versions/{id}`.replace(`{${"content_id"}}`, encodeURIComponent(String(requestParameters.contentId))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VersionUpdateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentVersionUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentContentIdVersionsIdPut(requestParameters: CompanySpacesContentContentIdVersionsIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentVersionUpdateResponse> {
        const response = await this.companySpacesContentContentIdVersionsIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async companySpacesContentContentIdVersionsPostRaw(requestParameters: CompanySpacesContentContentIdVersionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentVersionCreateResponse>> {
        if (requestParameters.contentId === null || requestParameters.contentId === undefined) {
            throw new runtime.RequiredError('contentId','Required parameter requestParameters.contentId was null or undefined when calling companySpacesContentContentIdVersionsPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/company_spaces/content/{content_id}/versions`.replace(`{${"content_id"}}`, encodeURIComponent(String(requestParameters.contentId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VersionCreateToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentVersionCreateResponseFromJSON(jsonValue));
    }

    /**
     */
    async companySpacesContentContentIdVersionsPost(requestParameters: CompanySpacesContentContentIdVersionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentVersionCreateResponse> {
        const response = await this.companySpacesContentContentIdVersionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorVersionsIdGetRaw(requestParameters: ContentEditorVersionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorShowResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorVersionsIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/versions/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorShowResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorVersionsIdGet(requestParameters: ContentEditorVersionsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorShowResponse> {
        const response = await this.contentEditorVersionsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorVersionsIdMetaGetRaw(requestParameters: ContentEditorVersionsIdMetaGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorMetaMetaResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorVersionsIdMetaGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/content_editor/versions/{id}/meta`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorMetaMetaResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorVersionsIdMetaGet(requestParameters: ContentEditorVersionsIdMetaGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorMetaMetaResponse> {
        const response = await this.contentEditorVersionsIdMetaGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async contentEditorVersionsIdMetaPutRaw(requestParameters: ContentEditorVersionsIdMetaPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContentEditorMetaUpdateResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling contentEditorVersionsIdMetaPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/content_editor/versions/{id}/meta`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: VersionUpdate1ToJSON(requestParameters.body),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContentEditorMetaUpdateResponseFromJSON(jsonValue));
    }

    /**
     */
    async contentEditorVersionsIdMetaPut(requestParameters: ContentEditorVersionsIdMetaPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContentEditorMetaUpdateResponse> {
        const response = await this.contentEditorVersionsIdMetaPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
